import { Head, Link, useForm, usePage } from "@inertiajs/react";
import AuthShell from "@/components/auth/AuthShell";
import ActivationCard from "@/components/parents/ActivationCard";

/**
 * /activate for someone not signed in — usually straight from the QR
 * code on a take-home sheet, with ?code= filled in. Always answers with
 * the same "check your email" page, so codes can't be guessed from it.
 */
export default function New({ claim_code, submit_path, user_email }) {
  const { routes } = usePage().props;
  const { data, setData, post, processing, errors } = useForm({
    claim_code: claim_code || "",
    email: user_email || "",
    privacy_consent: false,
  });

  const submit = (e) => {
    e.preventDefault();
    post(submit_path);
  };

  return (
    <AuthShell helpHref={routes.help_parents}>
      <Head title="Activate your child's reading page" />
      <ActivationCard
        claim_code={data.claim_code}
        email={data.email}
        onChange={(field, value) => setData(field, value)}
        onSubmit={submit}
        processing={processing}
        errors={{ claim_code: errors.claim_code, email: errors.email, privacy_consent: errors.privacy_consent }}
        variant="public"
        showPrivacyConsent
        privacyConsent={data.privacy_consent}
      />
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Already activated?{" "}
        <Link href={routes.sign_in} className="font-medium text-primary hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
